import * as React from 'react';
import { Modal, Input, Button, Dropdown, Menu } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import Form, { FormItem } from '../../../../../components/Form';
import DeliveryMethodSelect from '../../../../../components/Others/DeliveryMethodSelect';

interface IShippingSettingsModalProps {
  order: GQL.IOrder;
  onSubmit: (data: any) => void;
  onClose: () => void;
}

interface IShippingSettingsModalState {
  data: {
    deliveryMethodId: string;
    deliveryTotal: number | null;
    shippingTrackingLink: string | null;
  };
  loading: boolean;
}

class ShippingSettingsModal extends React.Component<IShippingSettingsModalProps, IShippingSettingsModalState> {

  private form;

  constructor(props: IShippingSettingsModalProps) {
    super(props);

    this.state = {
      data: {
        deliveryMethodId: props.order.deliveryMethod.id,
        deliveryTotal: props.order.deliveryTotal,
        shippingTrackingLink: props.order.shippingTrackingLink,
      },
      loading: false,
    };

    this.form = React.createRef;

    this.onSubmit = this.onSubmit.bind(this);
    this.onChange = this.onChange.bind(this);
    this.getModalFooter = this.getModalFooter.bind(this);
  }

  public render() {
    const { order } = this.props;
    const { data } = this.state;

    return (
      <div>
        <Modal
          title="Shipping settings"
          visible={true}
          footer={this.getModalFooter()}
          okText={'Update'}
          // onOk={this.onSubmit}
          onCancel={this.props.onClose}
          destroyOnClose={true}
          maskClosable={false}
        >
          <Form
            ref={f => this.form = f}
            displayFooter={false}
            onSubmit={this.onSubmit}
            onCancel={this.props.onClose}
          >
            <FormItem label={'Delivery method'} required={true}>
              <DeliveryMethodSelect
                name={'deliveryMethodId'}
                value={data.deliveryMethodId}
                onChange={(e: any, method: GQL.IDeliveryMethod | undefined) => this.onChange(e)}
              />
            </FormItem>
            <FormItem label={'Price'} required={true}>
              <Input
                name={'deliveryTotal'}
                placeholder="Enter delivery price"
                addonBefore={order.currency && order.currency.value}
                value={data.deliveryTotal ? data.deliveryTotal.toString() : ''}
                required={true}
                onChange={this.onChange}
              />
            </FormItem>
            <FormItem label={'Package tracking link'}>
              <Input
                name={'shippingTrackingLink'}
                placeholder="Enter shipping tracking link"
                value={data.shippingTrackingLink || ''}
                onChange={this.onChange}
              />
            </FormItem>
          </Form>
        </Modal>
      </div>
    );
  }

  private getModalFooter() {
    const footer: JSX.Element[] = [];
    footer.push(<Button key="back" onClick={this.props.onClose}>Cancel</Button>);

    if (!!this.state.data.shippingTrackingLink && this.state.data.shippingTrackingLink !== '') {
      const menu = (
        <Menu onClick={(e: any) => this.onSubmit(e.key)}>
          <Menu.Item key="saveOrderSent">
            Save changes
          </Menu.Item>
          <Menu.Item key="saveOrderSent_ChangeOrderStatus">
            Save changes and change order status
          </Menu.Item>
          <Menu.Item key="saveOrderSent_ChangeOrderStatus_SendEmail">
            Save changes, change order status and send message
          </Menu.Item>
        </Menu>
      );

      footer.push(
        <Dropdown key="submit" overlay={menu}>
          <Button type="primary" loading={this.state.loading}>
            Choose option <DownOutlined />
          </Button>
        </Dropdown>
      );
    } else {

      footer.push(<Button key="submit" type="primary" onClick={(e: any) => this.onSubmit()}>Save changes</Button>);      
    }

    return footer;
  }

  private onChange(e: any) {
    const { name, value } = e.target;

    this.setState({
      data: { ...this.state.data, [name]: value }
    });
  }

  private onSubmit(action: string | null = null) {
    if (this.form) {
      if (this.form.validate()) {
        this.setState({
          loading: true,
        }, () => {
          this.props.onSubmit({...this.state.data, _action: action});
        });
      }
    }
  }
}

export default ShippingSettingsModal;


// WEBPACK FOOTER //
// ./src/scenes/OrderView/OrderView/ShippingSettings/components/Modal.tsx